import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { DadsAndGradsComponent } from './dads-and-grads.component';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule
  ],
  declarations: [
    DadsAndGradsComponent,
  ],
  providers: [
  ]
})
export class DadsAndGradsModule { }



// WEBPACK FOOTER //
// ./src/app/dads-and-grads/dads-and-grads.module.ts